// src/features/movimentacao-financeiro/movimentacaoFinanceiroAPI.js
import {
    doGetQCXRequest,
    doPostQCXRequest,
    doPutQCXRequest,
    doPutQCXActivateRequest,
    doPutQCXInactivateRequest,
  } from '../../utils/api/domain/domain-api-utils';
  
  const ENDPOINT = 'movimentacao-financeiro';
  
  export const register        = (data) => doPostQCXRequest([ENDPOINT], data);
  export const save            = (data) => doPutQCXRequest([ENDPOINT], data);
  export const fetchById       = (id)   => doGetQCXRequest([ENDPOINT, id]);
  export const activateById    = (id)   => doPutQCXActivateRequest([ENDPOINT], id);
  export const inactivateById  = (id)   => doPutQCXInactivateRequest([ENDPOINT], id);
  